import './App.css'
import Header from './components/Header/Header';
import ToolsPanel from './components/ToolsPanel/ToolsPanel';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import { useSelector, useDispatch } from 'react-redux';
import appSlice, { setActivePage } from './store/slices/appSlice';
import { useTranslation } from 'react-i18next';

export default function App() {
	const activePage = useSelector(appSlice.selectors.getActivePage);
	const authError = useSelector(appSlice.selectors.getAuthError);
	const dispatch = useDispatch();

	const { t } = useTranslation('profile');

	const handleOpenCalculator = () => {
		dispatch(setActivePage('calculator'));
	};

	return (
		<div className="app">
			<Header />
			{authError && <div role="alert">{t('menu.authError')}</div>}
			{activePage === 'calculator' && <ToolsPanel />}
			{activePage === 'userProfile' && <ProfilePage onClose={handleOpenCalculator} />}
		</div>
	);
}
